import type { FormControl, FormGroup } from '@angular/forms';

import type { GridsterItem } from 'angular-gridster2';
import type { ECharts } from 'echarts/core';

import type { AsFormControlMap } from '@core/common-legacy';
import type { AnySymbol } from '@core/symbol-legacy';
// eslint-disable-next-line boundaries/element-types
import type { Theme } from '@core/theme-util'; // --FIXME
import { type Visibility, VisibilityLevel } from '@core/visibility-types';

import { ReportDateFilter } from './common.types';
import { ReportDashboardUnavailabilityReason } from './consts.types';
import {
  ReportDashboardComponent,
  ReportDashboardComponentCreate,
  ReportParamFilters,
} from './report-component.types';

export const NO_LIMIT_DATA = -1;
export const DEFAULT_DATA_LIMIT = NO_LIMIT_DATA;

export const DASHBOARD_BASE_PATH = 'boards/:dashboardId';

export const REPORTS_DEFAULT_VISIBILITY = {
  adminIds: [],
  level: VisibilityLevel.Private,
  roleIds: [],
};

export type ChartFactory = (
  el: HTMLDivElement | HTMLCanvasElement,
  theme: Theme,
  devicePixelRatio: number,
  locale: string,
  isExport?: boolean,
) => ECharts;

export enum DataInterval {
  Daily = 'daily',
  Weekly = 'weekly',
  Monthly = 'monthly',
  Quarterly = 'quarterly',
}

export enum VisualizationContext {
  Preview = 'preview',
  Library = 'library',
  Builder = 'builder',
  TemplatesLibrary = 'templates-library',
  Export = 'export',
}

export const SortedIntervals = [
  DataInterval.Daily,
  DataInterval.Weekly,
  DataInterval.Monthly,
  DataInterval.Quarterly,
];

export interface DashboardComponentGridsterItem extends GridsterItem {
  localId: string | null;
  refComponentId?: number;
}

export interface GlobalFilterFormValue {
  dateFilter: ReportDateFilter;
  queryFilter: string;
}

export type GlobalFilterForm = FormGroup<{
  dateFilter: FormGroup<AsFormControlMap<GlobalFilterFormValue['dateFilter']>>;
  queryFilter: FormControl<GlobalFilterFormValue['queryFilter']>;
}>;

export const ReturnToLibraryToken = 'ReturnToLibraryToken';
export const ReturnToStartFromScratchToken = 'ReturnToStartFromScratchToken';

export type ReportDashboardsAbilities = {
  canManageReportDashboards: boolean;
  canViewReportDashboards: boolean;
  canExportData: boolean;
  canViewHiredCandidates: boolean;
  canManageRequisitions: boolean;
  canCreateCustomDashboards: boolean;
};

export interface ReportDashboardFilters {
  filters: ReportParamFilters;
  dateFilter: ReportDateFilter;
}

export interface ReportDashboardApiEntity {
  id: number;
  name: string;
  filters: ReportParamFilters;
  dateFilter: ReportDateFilter;
  components: ReportDashboardComponent[];
  isAvailable: boolean;
  unavailableReason: null | ReportDashboardUnavailabilityReason;
  origin: 'template' | null | 'duplicate' | 'blank';
  templateId: string | null;
  showBanner: boolean;
  deprecated: boolean;
  symbol: AnySymbol | null;
  generated: boolean;
  visibility: Visibility;
  duplicated?: boolean;
}

export interface ReportDashboard extends Omit<ReportDashboardApiEntity, 'components'> {
  componentIds: Array<number | string>; // FE only
}

export type ReportsDashboardCreate = Partial<
  Omit<ReportDashboardApiEntity, 'id' | 'components'> & {
    components: ReportDashboardComponentCreate[];
  }
>;

export interface ReportDashboardWithReferences extends ReportDashboard {
  components: ReportDashboardComponent[];
  position: number;
}
